document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
    $('.product').each(function() {       
        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }
        
    });
}